export default __webpack_public_path__ + "static/media/phone.3efe01b8.png";